import { uploadFilePhoto } from 'core/crud/upload.crud';
import { useTranslate } from 'core/hooks/useTranslate';
import React from 'react';
import { useToasts } from 'react-toast-notifications';

type UseDialogPhotoProps = {
  open: boolean;
  onRefresh: () => void;
  program: any;
  item: any;
  setOpen: (open: boolean) => void;
  update?: (data: any) => void;
};

type UseDialogPhotoReturn = {
  photo: string | undefined;
  url: string;
  onChangePhoto: (event: string) => void;
  onCloseModal: () => void;
  onSuccess: () => Promise<void>;
  setPhoto: (photo: string | undefined) => void;
};

function useDialogPhoto({ open, onRefresh, program, item, setOpen, update }: UseDialogPhotoProps): UseDialogPhotoReturn {
  const { addToast } = useToasts();
  const { t } = useTranslate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [photo, setPhoto] = React.useState<string | undefined>(undefined);
  const [url, setUrl] = React.useState<string>('');

  React.useEffect(() => {
    if (open) {
      setUrl(item.image ? item.image : '');
    } else {
      setUrl('');
    }
  }, [open, item.image]);

  function onChangePhoto(event: string): void {
    setPhoto(event);
    setUrl(event);
  }

  function onCloseModal(): void {
    setOpen(false);
    setPhoto(undefined);
  }

  function refresh(): void {
    setTimeout(() => {
      onRefresh();
      setIsLoading(false);
    }, 500);
  }

  async function onSuccess(): Promise<void> {
    setIsLoading(true);

    try {
      if (photo) {
        await uploadFilePhoto({
          blob: true,
          file: photo,
          fileName: 'image-course',
          onEnd: refresh,
          openToast: () => addToast(t('common:Error updating image'), { appearance: 'error' }),
          urlToken: `front/courses/${program.guid}/items/${item.guid}/image-blob`,
        });
      } else {
        await update({ image: '' });
      }
    } catch (error) {
      addToast(t('common:Error updating image'), { appearance: 'error', autoDismiss: true });
      setIsLoading(false);
    }

    onCloseModal();
  }

  return {
    photo,
    url,
    onChangePhoto,
    onCloseModal,
    onSuccess,
    setPhoto,
  };
}

export default useDialogPhoto;
